// @ts-nocheck
/**
 * Re-export only the lucide icons we actually use.
 * This prevents bundling all 500+ icons from lucide-react.
 * Direct ESM imports don't have type declarations, hence @ts-nocheck above.
 */

// Direct imports from individual icon files for tree-shaking
// Icons use default exports, so we import default and re-export with names
export { default as AlertTriangle } from 'lucide-react/dist/esm/icons/alert-triangle';
export { default as Check } from 'lucide-react/dist/esm/icons/check';
export { default as ChevronDown } from 'lucide-react/dist/esm/icons/chevron-down';
export { default as HomeIcon } from 'lucide-react/dist/esm/icons/home';
export { default as LayersIcon } from 'lucide-react/dist/esm/icons/layers';
export { default as Loader2 } from 'lucide-react/dist/esm/icons/loader-2';
export { default as LogOut } from 'lucide-react/dist/esm/icons/log-out';
export { default as Maximize } from 'lucide-react/dist/esm/icons/maximize';
export { default as Menu } from 'lucide-react/dist/esm/icons/menu';
export { default as Minimize } from 'lucide-react/dist/esm/icons/minimize';
export { default as NewspaperIcon } from 'lucide-react/dist/esm/icons/newspaper';
export { default as Pause } from 'lucide-react/dist/esm/icons/pause';
export { default as Play } from 'lucide-react/dist/esm/icons/play';
export { default as Search } from 'lucide-react/dist/esm/icons/search';
export { default as Settings } from 'lucide-react/dist/esm/icons/settings';
export { default as User } from 'lucide-react/dist/esm/icons/user';
export { default as UserIcon } from 'lucide-react/dist/esm/icons/user';
export { default as Volume2 } from 'lucide-react/dist/esm/icons/volume-2';
export { default as VolumeX } from 'lucide-react/dist/esm/icons/volume-x';
export { default as Wand2Icon } from 'lucide-react/dist/esm/icons/wand-2';
export { default as X } from 'lucide-react/dist/esm/icons/x';
